<script lang="ts" setup>
import type { BlokHikingReference } from "@/.storyblok/types/120421/storyblok-components";
import BaseRichtext from "~/components/BaseRichtext.vue";

const props = defineProps<{
  blok: BlokHikingReference;
}>();

const localePath = useLocalePath();
</script>

<template>
  <div class="grid gap-8 xs:gap-10 md:gap-12 md:grid-cols-2 lg:grid-cols-3" v-editable="blok">
    <div v-for="reference in blok.hikes" :key="reference._uid" class="reference-container">
      <div class="reference grid gap-4 justify-items-stretch h-full">
        <BaseImage
          class="reference__media"
          v-bind="reference.content.referenceTeaserImage"
          aspect-ratio="4/3"
        ></BaseImage>
        <div class="reference__content">
          <div>
            <div class="font-optimus text-2xl">{{reference.content?.referenceTeaserTitle}}</div>
            <BaseRichtext :content="reference.content.referenceTeaserDescription"/>
          </div>
          <BaseButton :is-primary="true" :is-story="true" :href="localePath('/' + reference.full_slug)" class="mt-6 text-center justify-self-start self-end">{{ reference.content.referenceTeaserButtonText }}</BaseButton>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.reference-container {
  container-name: hikingReference;
  container-type: inline-size;
}

.reference {
  align-items: stretch;
  grid-template-rows: auto 1fr;
}

.reference__media {
  flex-grow: 0;
  flex-shrink: 0;;
}

.reference__content {
  flex-grow: 1;
  display: grid;
  align-items: start;
}

@container hikingReference (width > 500px) {
  .reference { 
    grid-template-columns: 1fr 1fr;
    gap: 2rem;
  }
}
</style>